import axios from 'axios';

import accessLocalStorage from './accessLocalStorage';
import { runRequest } from './apiResult';

const postAuthorized = async (path, body) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  return axios.post(`${ipRequest}${path}`, body, { headers: { Authorization: token } });
};

export const deactivateUser = async (data) =>
  runRequest(() => postAuthorized('api/login/delete', data), {
    fallback: 'Não foi possível desativar o usuário.'
  });

export const deleteUserPermanently = async (data) =>
  runRequest(() => postAuthorized('api/login/delete-permanent', data), {
    fallback: 'Não foi possível excluir definitivamente o usuário.'
  });
